import type { Attributes } from '@opentelemetry/api';
import type { ReactNode } from 'react';
import { withServerSpan } from './serverSpan';

type ServerSpanHOCOptions = {
  attributes?: Attributes;
  tracerName?: string;
};

/**
 * Wraps a React Server Component in a server span so the whole render is one trace boundary.
 */
export function WithServerSpanHOC<P extends object>(
  spanName: string,
  Component: (props: P) => Promise<ReactNode>,
  options?: ServerSpanHOCOptions,
): (props: P) => Promise<ReactNode> {
  return async function tracedComponent(props: P) {
    return withServerSpan(spanName, () => Component(props), options);
  };
}
